const React = require('react');

class Section extends React.Component {
    render() {
        return (
        <section className={`section ${this.props.className}`}>
            {this.props.children}
        </section>
        )
    }
}

module.exports = Section;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Section/index.jsx